import { string } from "yup";
const maxTextLength = 32768;
const tooLongMessage = "Too many characters entered.";
/**
 * Who makes the decision the form records: the person completing the form, or
 * another individual, whose name is then required. Section 5 of the
 * Mental Capacity Act protects a decision maker only if they took reasonable
 * steps to establish that the person lacks capacity, and reasonably believe the
 * act is in the person's best interests.
 */
export const responsibleDecisionMakerSchemaFields = () => ({
    responsibleDecisionMaker: string()
        .oneOf(["person_completing_form", "another_individual", ""])
        .default(""),
    responsibleDecisionMakerName: string()
        .trim()
        .max(maxTextLength, tooLongMessage)
        .default("")
        .when("responsibleDecisionMaker", {
        is: "another_individual",
        then: (s) => s.required("Please enter the name of the responsible decision maker"),
        otherwise: (s) => s.notRequired(),
    }),
});
//# sourceMappingURL=responsibleDecisionMakerSchemaFields.js.map